import { render, staticRenderFns } from "./templateMessage.vue?vue&type=template&id=ec382ab4&"
import script from "./templateMessage.vue?vue&type=script&lang=js&"
export * from "./templateMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports